import gameData from "../../gameData.js";
import TrayBaseDraggers from './trayBaseDraggers.js';

export default class PatchTray extends TrayBaseDraggers
{
    constructor(scene, parentCont, type, ind)
    {
        super(scene, parentCont, type, ind);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type;
        this.ind = ind;

        this.hasSlider = true;
        this.stepper = 0;
        this.spacing = 32;
        this.maxVisible = 6;
        this.sliderPos = {
            x: 55,
            upStart:-405,
            upEnd: -355,
            downStart: 386,
            downEnd: 336
        };

        this.createPatchTray();

        this.setPosition(0, 0);
        this.scene.addToParent(this, this.pCont);
    }

    createPatchTray()
    {
        let patchRef = ["Butterfly", "Car", "Fuzzbug", "Rainbow", "Smiley", "Star", "Logo", "Heart", "IceCream", "Flowers"];

        this.btnUp = this.scene.addButton(this.sliderPos.x, this.sliderPos.upStart, "Btn_Up", null, ()=>{this.scrollUp();}, this);
        this.btnDown = this.scene.addButton(this.sliderPos.x, this.sliderPos.downStart, "Btn_Down", null, ()=>{this.scrollDown();}, this);
        
        this.moveUp(this.nameplate);
        this.moveUp(this.nameplate);
        this.moveUp(this.nameplateText);
        this.moveUp(this.nameplateText);

        for(let i=0;i<patchRef.length;i++){
            let patch = this.scene.addImage(0, 0, "Patch_"+patchRef[i], this);
            patch.isClone = false;
            patch.baseScale = .5;
            patch.type = "patch";
            patch.ind = i;

            this.sendToBack(patch);
            patch.setScale(.3, .3);
            patch.x = patch.startX = this.sliderPos.x;
            this.accessories.push(patch);

            if(i === 0){
                patch.y = patch.startY = -260;
            } else {
                patch.y = patch.startY = this.accessories[i-1].y + (this.accessories[i-1].height/2 * this.accessories[i-1].scaleY) + (patch.height/2 * patch.scaleY) + this.spacing;
            }

            this.addDragFunctions(patch);
        }
    }

    checkScrollState()
    {
        this.toggleBtns();

        if(this.stepper === 0) {
            this.scene.addTween(this.btnUp, 250, {y:this.sliderPos.upStart}, Phaser.Math.Easing.Quadratic.Out);
            this.scene.addTween(this.btnDown, 250, {y:this.sliderPos.downEnd}, Phaser.Math.Easing.Quadratic.Out);
        }
        else if(this.stepper > 0 && this.stepper + this.maxVisible < this.accessories.length) {
            this.scene.addTween(this.btnUp, 250, {y:this.sliderPos.upEnd}, Phaser.Math.Easing.Quadratic.Out);
            this.scene.addTween(this.btnDown, 250, {y:this.sliderPos.downEnd}, Phaser.Math.Easing.Quadratic.Out);
        }
        else if(this.stepper > 0 && this.stepper + this.maxVisible >= this.accessories.length) {
            this.scene.addTween(this.btnUp, 250, {y:this.sliderPos.upEnd}, Phaser.Math.Easing.Quadratic.Out);
            this.scene.addTween(this.btnDown, 250, {y:this.sliderPos.downStart}, Phaser.Math.Easing.Quadratic.Out);
        }

        this.scene.addDelay(250, ()=>{this.toggleBtns(true);});
    }

    scrollUp()
    {
        this.stepper--;

        for(let i=0;i<this.accessories.length;i++){
            let newY = this.accessories[i].y + ((this.accessories[this.stepper+1].height/2 * this.accessories[this.stepper+1].scaleY) + (this.accessories[this.stepper].height/2 * this.accessories[this.stepper].scaleY) + this.spacing*2);
            this.accessories[i].startY = newY;
            
            this.scene.killTween(this.accessories[i]);
            this.scene.addTween(this.accessories[i], 250, {y:newY}, Phaser.Math.Easing.Quadratic.InOut);
        }

        this.checkScrollState();
    }

    scrollDown()
    {
        this.stepper++;

        for(let i=0;i<this.accessories.length;i++){
            let newY = this.accessories[i].y - ((this.accessories[this.stepper-1].height/2 * this.accessories[this.stepper-1].scaleY) + (this.accessories[this.stepper].height/2 * this.accessories[this.stepper].scaleY) + this.spacing*2);
            this.accessories[i].startY = newY;
            
            this.scene.killTween(this.accessories[i]);
            this.scene.addTween(this.accessories[i], 250, {y:newY}, Phaser.Math.Easing.Quadratic.InOut);
        }

        this.checkScrollState();
    }

    cleanUp()
    {
        this.toggleBtns(false);
        //this.accessories.forEach(patch => {patch.destroy();});
        //this.nameplate.destroy();
        //this.nameplateText.destroy();
    }
}